import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'educare-auth',
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
  imports: [TranslateModule]
})
export class AuthComponent {}
